<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex flex-row flex-nowrap md:gap-3 items-center justify-between">
  <div class="flex flex-wrap w-1/4 justify-start">
    <img
      [routerLink]="['/events']"
      class="left-arrow clickable"
      src="../../../../assets/icons/left-arrow.svg"
      alt="event"
    />
    <h1 *ngIf="!isEdit" class="headeradminui-text pl-2">
      Create {{ recurring ? "Class" : "Event" }}
    </h1>
    <h1 *ngIf="isEdit && viewMode" class="headeradminui-text pl-2">
      View {{ recurring ? "Class" : "Event" }}
    </h1>
    <h1 *ngIf="isEdit && !viewMode" class="headeradminui-text pl-2">
      Edit {{ recurring ? "Class" : "Event" }}
    </h1>
  </div>
</div>

<nz-spin [nzSpinning]="pageLoading">
  <nz-card>
    <!-- Action Buttons -->
    <div *ngIf="isEdit" nz-row nzJustify="end" class="mb-4" nzGutter="16">
      <div nz-col>
        <nz-switch
          [(ngModel)]="active"
          [nzDisabled]="viewMode"
          nzCheckedChildren="Active"
          nzUnCheckedChildren="Inactive"
        ></nz-switch>
      </div>
      <div nz-col>
        <button
          *ngIf="viewMode"
          (click)="editForm()"
          nz-button
          nzType="primary"
        >
          <span nz-icon nzType="edit"></span>
          Edit Event
        </button>
      </div>
    </div>

    <!-- Event/Class Selector (only for create) -->
    <div *ngIf="!isEdit" class="mb-4">
      <nz-select
        [(ngModel)]="selectedValue"
        (ngModelChange)="onClassEventChange($event)"
        nzPlaceHolder="Select an option"
        style="width: 200px"
      >
        <nz-option nzValue="Event" nzLabel="Event"></nz-option>
        <nz-option nzValue="Class" nzLabel="Class"></nz-option>
      </nz-select>
    </div>

    <!-- Main Form -->
    <form [formGroup]="validateForm" nz-form>
      <!-- Title, Category, Duration Row -->
      <div nz-row nzGutter="16">
        <div nz-col nzSpan="16">
          <nz-form-item>
            <nz-form-label nzFor="eventName" nzRequired nzSpan="24">
              Title
            </nz-form-label>
            <nz-form-control nzErrorTip="Please input Title" nzSpan="24">
              <input
                formControlName="eventName"
                id="eventName"
                nz-input
                placeholder="Title"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="4">
          <nz-form-item>
            <nz-form-label nzRequired nzSpan="24"> Category </nz-form-label>
            <nz-form-control>
              <nz-select
                formControlName="selectedCategory"
                id="eventCategory"
                nzAllowClear
                nzPlaceHolder="Select a Event Category"
                nzShowSearch
              >
                <nz-option
                  *ngFor="let category of eventCategories"
                  [nzLabel]="category.label"
                  [nzValue]="category.value"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="4">
          <nz-form-item>
            <nz-form-label nzFor="eventDuration" nzRequired nzSpan="24">
              Duration in Minutes
            </nz-form-label>
            <nz-form-control nzSpan="24">
              <input
                formControlName="eventDuration"
                nz-input
                placeholder="Duration in Minutes"
                type="number"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Description and Key Points Row -->
      <div class="mt-5" nz-row nzGutter="10">
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label nzFor="eventDescription" nzRequired nzSpan="24">
              Description
            </nz-form-label>
            <nz-form-control nzSpan="24">
              <textarea
                formControlName="eventDescription"
                id="eventDescription"
                nz-input
                placeholder="Event Description"
                rows="10"
              ></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div *ngIf="!recurring" nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label nzFor="keyPoints" nzSpan="24">
              Key Points
            </nz-form-label>
            <nz-form-control nzSpan="24">
              <textarea
                formControlName="keyPoints"
                id="keyPoints"
                nz-input
                placeholder="Key Points"
                rows="10"
              ></textarea>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Date Fields Row -->
      <div class="mt-5" nz-row nzGutter="16">
        <div nz-col>
          <nz-form-item>
            <nz-form-label nzFor="eventDate" nzRequired nzSpan="24">
              Event Date
            </nz-form-label>
            <nz-form-control>
              <nz-date-picker
                [nzFormat]="dateTimeFormat"
                formControlName="eventDate"
                id="eventDate"
                nzShowTime
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div *ngIf="recurring" nz-col>
          <nz-form-item>
            <nz-form-label nzFor="eventEndDate" nzRequired nzSpan="24">
              Event End Date
            </nz-form-label>
            <nz-form-control>
              <nz-date-picker
                [nzFormat]="dateFormat"
                [nzDisabledDate]="disableEndDate"
                formControlName="eventEndDate"
                id="eventEndDate"
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col>
          <nz-form-item>
            <nz-form-label nzFor="visibleTime" nzRequired nzSpan="24">
              Visible From Start of Date
            </nz-form-label>
            <nz-form-control>
              <nz-date-picker
                [nzFormat]="dateFormat"
                formControlName="visibleTime"
                id="visibleTime"
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div *ngIf="!recurring" nz-col>
          <nz-form-item>
            <nz-form-label nzFor="cutOffTime" nzRequired nzSpan="24">
              Registration Cut Off By the end of Selected Date
            </nz-form-label>
            <nz-form-control>
              <nz-date-picker
                [nzFormat]="dateFormat"
                formControlName="registrationCutOff"
                id="cutOffTime"
              ></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="4">
          <nz-form-item>
            <nz-form-label nzFor="maximumRegistrations" nzRequired nzSpan="24">
              Max Registration Count
            </nz-form-label>
            <nz-form-control nzSpan="24">
              <input
                formControlName="maximumRegistrations"
                nz-input
                placeholder="Max Registration Count"
                type="number"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Recurring Fields -->
      <nz-divider *ngIf="recurring"></nz-divider>
      <div *ngIf="recurring" nz-row nzGutter="16">
        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>
            RRText (Please generate from
            <a href="https://icalendar.org/rrule-tool.html" target="_blank" class="text-blue-600 pl-1">
              https://icalendar.org/rrule-tool.html
            </a>
            )
          </nz-form-label>
          <nz-form-control nzSpan="24">
            <input
              [(ngModel)]="rrText"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="viewMode"
              nz-input
              placeholder="RRText"
              type="text"
            />
          </nz-form-control>
        </div>
        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>
            Cron Text (Please generate from
            <a href="https://crontab.guru/#" target="_blank" class="text-blue-600 pl-1">
              https://crontab.guru/#
            </a>
            )
          </nz-form-label>
          <nz-form-control nzSpan="24">
            <input
              [(ngModel)]="cronText"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="viewMode"
              nz-input
              placeholder="CronText"
              type="text"
            />
          </nz-form-control>
        </div>
      </div>
      <div *ngIf="recurring" nz-row nzGutter="16">
        <div nz-col nzSpan="12">
          <nz-form-label nzRequired>
            Recurring Frequency Text (This Text will display in the app to the users)
          </nz-form-label>
          <nz-form-control>
            <input
              [(ngModel)]="recurringFrequencyText"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="viewMode"
              nz-input
              placeholder="Every Monday or Every Wednesday,Friday"
              type="text"
            />
          </nz-form-control>
        </div>
      </div>

      <nz-divider></nz-divider>

      <!-- Languages and Payment Type -->
      <div class="mt-5" nz-row nzGutter="16">
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label nzFor="language" nzRequired>
              Languages
            </nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-select
                formControlName="selectedLanguages"
                id="language"
                nzAllowClear
                nzMode="tags"
                nzPlaceHolder="Languages"
                nzShowSearch
              >
                <nz-option
                  *ngFor="let language of languages"
                  [nzLabel]="language"
                  [nzValue]="language"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label nzRequired>Event Payment Types</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-select formControlName="eventPaymentType" id="eventType">
                <nz-option
                  *ngFor="let type of eventPaymentTypes"
                  [nzLabel]="type"
                  [nzValue]="type"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
          <div class="mt-2">
            <ul>
              <li><span nz-typography><strong>Free</strong></span> - Free for all Customers</li>
              <li><b>Paid</b> - Paid for all Customers</li>
              <li><b>Retail Paid</b> - Free for Corporate users, Paid for retail users</li>
              <li><b>Corporate Paid</b> - Free for Retail users, Paid for Corporate users</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Club Passes -->
      <div
        *ngIf="clubPasses!.length > 0 && validateForm.get('eventPaymentType')?.value !== 'Free'"
        class="my-5"
        nz-row
        nzGutter="16"
      >
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label nzFor="clubPass">Club Passes</nz-form-label>
            <nz-form-control nzSpan="24">
              <nz-select
                formControlName="applicableClubPasses"
                id="clubPass"
                nzAllowClear
                nzMode="tags"
                nzPlaceHolder="Select a Club Pass"
                nzShowSearch
              >
                <nz-option
                  *ngFor="let clubPass of clubPasses"
                  [nzLabel]="clubPass.passName"
                  [nzValue]="clubPass"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>

    <!-- Corporate Only Event Switch -->
    <div nz-row class="mt-3">
      <div nz-col>
        <nz-switch
          [(ngModel)]="corporateOnlyEvent"
          [nzDisabled]="viewMode"
          nzCheckedChildren="Corporate Only"
          nzUnCheckedChildren="All Customers"
        ></nz-switch>
      </div>
    </div>

    <!-- Partner Selection -->
    <div *ngIf="corporateOnlyEvent" nz-row class="mt-2">
      <div nz-col nzSpan="12">
        <nz-select
          [(ngModel)]="selectedPartners"
          [nzDisabled]="viewMode"
          class="min-w-[400px]"
          nzShowSearch="true"
          nzMode="multiple"
          nzPlaceHolder="Select Partners"
        >
          <nz-option
            *ngFor="let partner of partners"
            [nzLabel]="partner.partner"
            [nzValue]="partner.id"
          ></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Venue Details -->
    <nz-divider nzOrientation="left" nzText="Venue Details"></nz-divider>
    <div nz-row>
      <div nz-col nzSpan="12">
        <nz-switch
          [(ngModel)]="offlineEvent"
          [nzDisabled]="viewMode"
          nzCheckedChildren="Offline"
          nzUnCheckedChildren="Online"
        ></nz-switch>
      </div>
    </div>
    <div *ngIf="offlineEvent" nz-row>
      <div nz-col nzSpan="12">
        <nz-form-item>
          <nz-form-label nzFor="venueName" nzRequired> Venue Name </nz-form-label>
          <nz-form-control nzSpan="24">
            <input
              [(ngModel)]="venue"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="viewMode"
              nz-input
              placeholder="Venue Name"
            />
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <!-- Thumbnail Image -->
    <nz-divider nzOrientation="left" nzText="Thumbnail Image"></nz-divider>
    <div nz-row nzGutter="16">
      <div nz-col nzSpan="12">
        <span><b>Thumbnail Image (Single, ratio of image dimension should be 1:1)</b></span>
        <br />
        <input
          [disabled]="viewMode"
          (change)="uploadThumbnailImage($event)"
          accept=".jpg,.jpeg,.png"
          type="file"
        />
        <div
          *ngIf="squareImagePreviewUrl || squareImageLink"
          nz-col
          nzSpan="12"
          style="width: 100px"
          class="pt-3"
        >
          <img
            [src]="squareImagePreviewUrl || squareImageLink"
            class="h-fit object-cover"
            alt="thumbnail"
          />
        </div>
      </div>
    </div>

    <!-- Banner Images -->
    <nz-divider nzOrientation="left" nzText="Banner Images"></nz-divider>
    <div nz-row>
      <div nz-col nzSpan="12">
        <span><b>Banner Images (Multiple, ratio of image dimension should be 2:1)</b></span>
        <br />
        <input
          [disabled]="viewMode"
          (change)="uploadImages($event)"
          multiple
          accept=".jpg,.jpeg,.png"
          type="file"
        />
        <div *ngFor="let image of selectedBannerFiles" class="mt-2">
          <p class="text-sm text-gray-600">{{ image.name }}</p>
        </div>
      </div>
    </div>
    <!-- Selected Banner Previews -->
    <div nz-row class="pt-3" *ngIf="bannerImagesPreviewUrls.length">
      <div
        nz-col
        *ngFor="let preview of bannerImagesPreviewUrls; let i = index"
        style="width: 200px"
        class="pr-3 pb-3"
      >
        <img [src]="preview" class="h-fit object-cover" alt="banner preview" />
        <div class="pt-2">
          <button
            *ngIf="!viewMode"
            (click)="deleteBannerPreview(i)"
            nz-button
            nzDanger
            nzSize="small"
          >
            <span nz-icon nzType="delete"></span>
            Delete
          </button>
        </div>
      </div>
    </div>
    <!-- Existing Banner Images -->
    <div class="flex flex-wrap justify-start items-center pr-4 pb-5">
      <div *ngFor="let data of imagesLinks; index as i" class="pt-5 pr-3">
        <nz-card style="width: 200px">
          <img [src]="data" class="h-fit object-cover" alt="banner" />
        </nz-card>
        <div class="pt-2">
          <button
            *ngIf="!viewMode"
            (click)="deleteImage(i)"
            nz-button
            nzDanger
            nzSize="small"
          >
            <span nz-icon nzType="delete"></span>
            Delete
          </button>
        </div>
      </div>
    </div>

    <!-- Share Details -->
    <nz-divider nzOrientation="left" nzText="Share Details"></nz-divider>
    <div nz-row nzGutter="16">
      <div nz-col nzSpan="10">
        <nz-form-label nzRequired nzSpan="24"> Share Message </nz-form-label>
        <textarea
          [disabled]="viewMode"
          [(ngModel)]="shareMessage"
          nz-input
          rows="4"
          placeholder="Enter share message"
        ></textarea>
      </div>
      <div nz-col nzSpan="6">
        <span><b>Upload Share Image (Single, ratio of image dimension should be 2:1)</b></span>
        <br />
        <input
          [disabled]="viewMode"
          (change)="uploadShareImage($event)"
          accept=".jpg,.jpeg,.png"
          type="file"
        />
        <div
          *ngIf="shareImagePreviewUrl || shareImageLink"
          nz-col
          nzSpan="12"
          style="width: 300px"
          class="pt-3"
        >
          <img
            [src]="shareImagePreviewUrl || shareImageLink"
            class="h-fit object-cover"
            alt="shareImage"
          />
        </div>
      </div>
    </div>

    <!-- Entry Fee Details -->
    <nz-divider
      *ngIf="eventEntryFee.length"
      nzOrientation="left"
      nzText="Entry Fee Details"
    ></nz-divider>
    <div *ngIf="!viewMode && validateForm.get('eventPaymentType')?.value !== 'Free'">
      <div nz-row nzJustify="end" class="mb-3">
        <button (click)="addEntryFee()" nz-button nzType="dashed">
          <span nz-icon nzType="plus"></span>
          Add Entry Fee
        </button>
      </div>
    </div>
    <div>
      <div
        *ngFor="let fee of eventEntryFee; index as i"
        nz-row
        nzGutter="16"
        class="mb-3"
      >
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzRequired nzSpan="24"> Amount </nz-form-label>
            <nz-form-control>
              <nz-input-group nzPrefix="₹" nzSuffix="INR">
                <input
                  [(ngModel)]="fee.amount"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="Amount"
                  type="number"
                />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="8">
          <nz-form-item>
            <nz-form-label nzRequired nzSpan="24"> MarkUp </nz-form-label>
            <nz-form-control>
              <nz-input-group nzPrefix="₹" nzSuffix="INR">
                <input
                  [(ngModel)]="fee.markupPrice"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="Markup Price"
                  type="number"
                />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
        <div
          *ngIf="!viewMode && eventEntryFee.length > 1"
          nz-col
          nzSpan="4"
          class="flex items-end pb-3"
        >
          <button (click)="eventEntryFee.splice(i, 1)" nz-button nzDanger>
            <span nz-icon nzType="delete"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- Guest Speaker Details -->
    <nz-divider nzOrientation="left" nzText="Guest Details"></nz-divider>
    <div *ngIf="!viewMode" nz-row nzJustify="end">
      <div nz-col>
        <button (click)="addGuestSpeaker()" nz-button nzType="primary">
          <span nz-icon nzType="download"></span>
          Add Guest Speaker
        </button>
      </div>
    </div>
    <div *ngFor="let speaker of guestSpeakerDetails; index as index">
      <nz-card class="mt-5" nzTitle="Guest Speaker {{ index + 1 }}">
        <div nz-row nzGutter="16">
          <div nz-col nzSpan="8">
            <nz-form-item>
              <nz-form-label nzRequired>Name</nz-form-label>
              <nz-form-control nzSpan="24">
                <input
                  [(ngModel)]="speaker.name"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="name"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSpan="8">
            <nz-form-item>
              <nz-form-label nzRequired>Email</nz-form-label>
              <nz-form-control nzSpan="24">
                <input
                  [(ngModel)]="speaker.email"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="Email"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSpan="8">
            <nz-form-item>
              <nz-form-label nzRequired>Qualification</nz-form-label>
              <nz-form-control nzSpan="24">
                <input
                  [(ngModel)]="speaker.qualification"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="Qualification"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row>
          <div class="mt-2" nz-col nzSpan="24">
            <nz-form-item>
              <nz-form-label nzRequired>Description</nz-form-label>
              <nz-form-control nzSpan="24">
                <textarea
                  [(ngModel)]="speaker.description"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="description"
                  rows="5"
                ></textarea>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <nz-divider nzText="Social Media Links"></nz-divider>
        <div nz-row nzGutter="16">
          <div nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label>Twitter</nz-form-label>
              <nz-form-control nzSpan="24">
                <input
                  [(ngModel)]="speaker.socialMediaLinks.twitter"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="Twitter"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label>Youtube</nz-form-label>
              <nz-form-control nzSpan="24">
                <input
                  [(ngModel)]="speaker.socialMediaLinks.youtube"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="Youtube"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="mt-2" nz-row nzGutter="16">
          <div nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label>Web</nz-form-label>
              <nz-form-control nzSpan="24">
                <input
                  [(ngModel)]="speaker.socialMediaLinks.web"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="Web"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label>Facebook</nz-form-label>
              <nz-form-control nzSpan="24">
                <input
                  [(ngModel)]="speaker.socialMediaLinks.faceBook"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="Facebook"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div class="mt-2" nz-row nzGutter="16">
          <div nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label>Linked In</nz-form-label>
              <nz-form-control nzSpan="24">
                <input
                  [(ngModel)]="speaker.socialMediaLinks.linkedIn"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="viewMode"
                  nz-input
                  placeholder="LinkedIn"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSpan="12">
            <div *ngIf="!viewMode" class="mt-2" nz-row nzAlign="bottom" nzJustify="end">
              <button
                (click)="deleteGuestSpeaker(index)"
                nz-button
                nzDanger
                nzType="primary"
              >
                Delete Guest Speaker
              </button>
            </div>
          </div>
        </div>
      </nz-card>
    </div>

    <!-- Presenter Details (presenterRows pattern from crud-forum) -->
    <nz-divider nzOrientation="left" nzText="Presenter Details"></nz-divider>
    <div
      *ngFor="let row of presenterRows; let i = index"
      nz-row
      nzGutter="16"
      style="margin-bottom: 20px; align-items: center"
    >
      <div nz-col nzSpan="8">
        <nz-select
          [disabled]="viewMode"
          [(ngModel)]="row.presenterId"
          nzPlaceHolder="Select Presenter"
          nzShowSearch
          nzAllowClear
          (ngModelChange)="onPresenterChange(i)"
          style="width: 100%"
        >
          <nz-option
            *ngFor="let expert of filteredExperts(i)"
            [nzLabel]="expert.expertId"
            [nzValue]="expert.name"
          ></nz-option>
        </nz-select>
      </div>
      <div nz-col nzSpan="4" *ngIf="row.presenterId">
        <label style="margin-right: 8px">Pay?</label>
        <nz-switch [(ngModel)]="row.isPaid" [disabled]="viewMode"></nz-switch>
      </div>
      <div nzSpan="6" *ngIf="row.isPaid" nz-row>
        <input
          nz-input
          type="number"
          [(ngModel)]="row.amount"
          placeholder="Amount"
          [disabled]="viewMode"
        />
        <span> INR (₹)</span>
      </div>
      <div nz-col nzSpan="2" *ngIf="i > 0">
        <button
          nz-button
          nzType="default"
          nzDanger
          (click)="removeRow(i)"
          [disabled]="viewMode"
        >
          X
        </button>
      </div>
    </div>
    <button
      nz-button
      nzType="default"
      (click)="addPresenterRow()"
      style="margin-top: 15px"
      [disabled]="viewMode"
    >
      + Add More Presenter
    </button>

    <!-- Events Bids Details -->
    <nz-divider nzOrientation="left" nzText="Events Bids Details"></nz-divider>
    <div nz-row>
      <div nz-col nzSpan="8">
        <nz-select
          [(ngModel)]="selectedBidId"
          [disabled]="viewMode || isEventBid"
          nzAllowClear
          nzPlaceHolder="Enter Bid detail"
          nzShowSearch
        >
          <nz-option
            *ngFor="let bid of bidsData"
            [nzLabel]="bid.eventName"
            [nzValue]="bid.id"
          ></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Meet Link and Video (only for edit mode) -->
    <div *ngIf="isEdit">
      <nz-divider nzOrientation="left" nzText="Meet Link & Video"></nz-divider>
      <div nz-row nzGutter="16">
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label nzSpan="24">Meet Link</nz-form-label>
            <nz-form-control nzSpan="24">
              <input
                [(ngModel)]="meetLink"
                [disabled]="viewMode"
                nz-input
                placeholder="Google Meet Link"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
        <div nz-col nzSpan="12">
          <nz-form-item>
            <nz-form-label nzSpan="24">Video Link</nz-form-label>
            <nz-form-control nzSpan="24">
              <input
                [(ngModel)]="videoLink"
                [disabled]="viewMode"
                nz-input
                placeholder="Video Link"
              />
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
      <div nz-row nzGutter="16" class="mt-3">
        <div nz-col nzSpan="6">
          <span><b>Upload Video</b></span>
          <br />
          <input
            [disabled]="viewMode"
            (change)="uploadVideo($event)"
            accept="video/*"
            type="file"
          />
        </div>
        <div nz-col nzSpan="6">
          <span><b>Upload Video Thumbnail</b></span>
          <br />
          <input
            [disabled]="viewMode"
            (change)="uploadThumbnail($event)"
            accept=".jpg,.jpeg,.png"
            type="file"
          />
          <div *ngIf="videoThumbnail" class="pt-3" style="width: 100px">
            <img [src]="videoThumbnail" class="h-fit object-cover" alt="video thumbnail" />
          </div>
        </div>
      </div>
    </div>

    <!-- Event Forum Settings -->
    <nz-divider nzOrientation="left" nzText="Event Forum Settings"></nz-divider>
    <div nz-row nzGutter="16">
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label>Discussion Available</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-switch
              [disabled]="viewMode"
              [(ngModel)]="isDiscussionAvailable"
              (ngModelChange)="onDiscussionAvailableChange()"
              nzCheckedChildren="Enabled"
              nzUnCheckedChildren="Disabled"
            ></nz-switch>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label>Users Can Post</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-switch
              [disabled]="viewMode || !isDiscussionAvailable"
              [(ngModel)]="canUserPost"
              nzCheckedChildren="Enabled"
              nzUnCheckedChildren="Disabled"
            ></nz-switch>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="8">
        <nz-form-item>
          <nz-form-label>Experts Can Post</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-switch
              [disabled]="viewMode || !isDiscussionAvailable"
              [(ngModel)]="canExpertPost"
              nzCheckedChildren="Enabled"
              nzUnCheckedChildren="Disabled"
            ></nz-switch>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-divider></nz-divider>

    <!-- Test checkboxes (only for create) -->
    <div nz-row *ngIf="!isEdit">
      <div nz-col>
        <label [(ngModel)]="testEvent" nz-checkbox>
          Test {{ recurring ? "Class" : "Event" }}
        </label>
      </div>
      <div nz-col>
        <label [(ngModel)]="testRealPayment" nz-checkbox>
          Test Real Payment
        </label>
      </div>
    </div>

    <!-- Action Buttons -->
    <nz-divider></nz-divider>
    <div *ngIf="!viewMode" nz-row nzJustify="space-between">
      <div nz-col>
        <button [routerLink]="['/events']" nz-button nzType="default">
          <span nz-icon nzType="arrow-left"></span>
          Cancel
        </button>
      </div>
      <div nz-col>
        <button
          (click)="addOrUpdateEvent()"
          nz-button
          nzType="primary"
          [nzLoading]="loading"
        >
          <span nz-icon [nzType]="isEdit ? 'save' : 'plus'"></span>
          {{ isEdit ? "Update " + (recurring ? "Class" : "Event") : "Create " + (recurring ? "Class" : "Event") }}
        </button>
      </div>
    </div>
  </nz-card>
</nz-spin>
